import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import PageWrapper from '../../shared/pagewrapper/PageWrapper.js';
import PageTitle from '../../shared/pagetitle/PageTitle.js';
import FormInscricao from './inscricao/FormInscricao.jsx';
import { ContextoResumoInscricaoProvider } from './inscricao/ContextoResumoInscricao.jsx';
import { STEP_LABELS } from './inscricao/inscricaoSections';
import { estadoInicialInscricao, montarEstadoInicial } from './inscricao/inscricaoPayload';
import { etapaSomenteConsulta } from './inscricao/periodoInscricao';

const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(4)
    },
    marginBottom: {
        marginBottom: theme.spacing(2)
    },
    divider: {
        margin: theme.spacing(2, 0)
    },
    detailText: {
        fontSize: '0.9rem',
        color: theme.palette.text.secondary
    },
    documentItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(0.5, 0)
    },
    checkIcon: {
        color: 'green',
        fontWeight: 'bold',
        marginLeft: theme.spacing(1)
    }
}));

export default function PageInscricaoNova() {
    const classes = useStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const [inscricao, setInscricao] = useState(estadoInicialInscricao);

    const identificacao = location.state?.identificacao;
    const etapaInicial = location.state?.initialStep || 0;
    /* Fora do período de inscrição a etapa pode abrir só para consulta. */
    const acaoTitulo = etapaSomenteConsulta(etapaInicial, identificacao) ? 'Consultar' : 'Editar';

    // Prefill identification details
    useEffect(() => {
        if (identificacao) {
            const isEdit = Boolean(location.state?.isEdit);
            setInscricao(montarEstadoInicial(identificacao, { isEdit }));
        } else {
            navigate('/publico/identificacao');
        }
    }, [identificacao, navigate, location.state]);

    const handleUpdateInscricao = (newData) => {
        setInscricao(prev => {
            const updated = {
                ...prev,
                ...newData
            };

            if (newData.endereco) {
                const pAddr = newData.endereco;
                const currentFamiliares = [...(updated.enderecoComposicaoFamiliares || [])];
                const resIdx = currentFamiliares.findIndex(addr => addr.tipoEndereco === 'RESIDENCIAL');

                if (pAddr.cep || pAddr.logradouro) {
                    const mappedCidade = pAddr.cidade || null;
                    const mappedUf = pAddr.cidade?.uf?.uf || pAddr.uf || '';

                    const residencialAddr = {
                        tipoEndereco: 'RESIDENCIAL',
                        cep: pAddr.cep || '',
                        logradouro: pAddr.logradouro || '',
                        numero: pAddr.numero || '',
                        complemento: pAddr.complemento || '',
                        bairro: pAddr.bairro || '',
                        cidade: mappedCidade,
                        uf: mappedUf
                    };

                    if (resIdx > -1) {
                        residencialAddr.id = currentFamiliares[resIdx].id;
                        currentFamiliares[resIdx] = residencialAddr;
                    } else {
                        currentFamiliares.push(residencialAddr);
                    }
                } else if (resIdx > -1) {
                    currentFamiliares.splice(resIdx, 1);
                }
                updated.enderecoComposicaoFamiliares = currentFamiliares;
            }

            return updated;
        });
    };

    return (
        <ContextoResumoInscricaoProvider valorInicial={inscricao}>
            <PageWrapper>
                <div className={classes.root}>
                    <PageTitle title={
                        location.state?.isEdit
                            ? `${acaoTitulo} Inscrição - ${STEP_LABELS[etapaInicial]}`
                            : 'Formulário de Inscrição Social'
                    } />
                    <FormInscricao
                        inscricao={inscricao}
                        onUpdate={handleUpdateInscricao}
                    />
                </div>
            </PageWrapper>
        </ContextoResumoInscricaoProvider>
    );
};
